import { useState, useEffect, useCallback } from 'react';
import axios, { API, authHeaders } from '../api';
import Layout from './Layout';
import { ui } from '../ui';
import { colors } from '../theme';
import DataTable from '../components/DataTable';

function fmt(str) {
  return new Date(str).toLocaleString('ru', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export default function Waitlist() {
  const [items, setItems] = useState([]);

  const fetchItems = useCallback(() => {
    axios.get(`${API}/admin/waitlist`, { headers: authHeaders() }).then(r => setItems(r.data));
  }, []);
  useEffect(() => { fetchItems(); }, [fetchItems]);

  return (
    <Layout>
      <h1 style={ui.title}>Лист ожидания (лендинг)</h1>
      <p style={{ color: colors.textMuted, fontSize: 13, marginTop: -10, marginBottom: 20 }}>
        Почты, оставленные на лендинге в форме "Узнать первым о запуске". Временный раздел — просто сбор для будущей рассылки.
      </p>
      <div style={ui.card}>
        <DataTable
          rows={items}
          rowKey={w => w.id}
          emptyText="Пока никто не оставил почту"
          columns={[
            { key: 'email', label: 'Почта' },
            { key: 'created_at', label: 'Дата', render: w => fmt(w.created_at) },
          ]}
        />
      </div>
    </Layout>
  );
}
